import { useEffect, useRef } from 'react';
export var useTrackedRef = function useTrackedRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
};